import { IkeObjectAnnotationSummary } from './annotation.summary.object';
import { IkeObjectCalibration } from './calibration.object';
import { IkeObjectCapture } from './capture.object';
import { IkeObjectCollectionHistory } from './collection.history.object';
import { IkeObjectCollection } from './collection.object';
import { IkeObjectCollectionSummary } from './collection.summary.object';
import { IkeObjectDepartment } from './department.object';
import { IkeObjectDevice } from './device.objects';
import { IkeObjectForm } from './form.object';
import { IkeObjectFormSummary } from './form.summary.object';
import { IkeObjectTag } from './tag.object';
import { IkeObjectTagSummary } from './tag.summary.object';
import { IkeObjectToken } from './token.object';
import { IkeObjectUserProfile } from './user.profile.object';

export { IkeRestObject as BaseIkeObject } from './base';

export const IkeRestObjects = {
	AnnotationSummary: new IkeObjectAnnotationSummary(),
	Calibration: new IkeObjectCalibration(),
	Capture: new IkeObjectCapture(),
	Collection: new IkeObjectCollection(),
	CollectionHistory: new IkeObjectCollectionHistory(),
	CollectionSummary: new IkeObjectCollectionSummary(),
	Department: new IkeObjectDepartment(),
	Device: new IkeObjectDevice(),
	Form: new IkeObjectForm(),
	FormSummary: new IkeObjectFormSummary(),
	Tag: new IkeObjectTag(),
	TagSummary: new IkeObjectTagSummary(),
	Token: new IkeObjectToken(),
	UserProfile: new IkeObjectUserProfile(),
};

export type IkeRestObjects = {
	AnnotationSummary: IkeObjectAnnotationSummary;
	Calibration: IkeObjectCalibration;
	Capture: IkeObjectCapture;
	Collection: IkeObjectCollection;
	CollectionSummary: IkeObjectCollectionSummary;
	Department: IkeObjectDepartment;
	Device: IkeObjectDevice;
	Form: IkeObjectForm;
	FormSummary: IkeObjectFormSummary;
	Tag: IkeObjectTag;
	TagSummary: IkeObjectTagSummary;
	Token: IkeObjectToken;
	UserProfile: IkeObjectUserProfile;
};
